export const ALL_POSTS_REQUEST = "ALL_POSTS_REQUEST"
export const ALL_POSTS_SUCCESS = "ALL_POSTS_SUCCESS"
export const ALL_POSTS_FAIL = "ALL_POSTS_FAIL"
export const CLEAR_ERRORS = "CLEAR_ERRORS"